var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhiteTwitterIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 35,
  height: 35,
  viewBox: "0 0 35 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1.02686,
  width: 33,
  height: 33,
  rx: 16.5,
  stroke: "white"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.9817 16.1481L25.5384 8.52637H23.9846L18.2915 15.1442L13.7443 8.52637H8.49976L15.3759 18.5338L8.49976 26.5264H10.0536L16.0657 19.5377L20.8678 26.5264H26.1124L18.9813 16.1481H18.9817ZM16.8535 18.6219L16.1568 17.6254L10.6134 9.69608H13L17.4736 16.0953L18.1703 17.0918L23.9854 25.4099H21.5988L16.8535 18.6223V18.6219Z",
  fill: "white"
})));
export default SvgWhiteTwitterIcon;